import React from 'react';
import IconRightly from '@/assets/images/menu/icon-rightly.react.svg?react';
import { MultiApp } from '@/config/context';
import { CapitalPlatform } from '@/infrastructure/utils/app';
import { MenuIcon } from '@/presentation/components/menu-icon';
import { IRouteConfig } from '../types';

export const rightlyRoutes = (): IRouteConfig[] => [
  {
    path: '/compliance',
    name: '应用合规',
    exact: true,
    whitelisted: true,
    icon: <MenuIcon icon={IconRightly} />,
    href: 'https://rightly.tds.qq.com?utm_source=buglypro&utm_medium=referral&source=buglypro',
    target: '_blank',
    versions: [MultiApp.Pro],
    platforms: [
      CapitalPlatform.Android,
      CapitalPlatform.IOS,
      CapitalPlatform.HarmonyOS,
      CapitalPlatform.VisionOS,
    ],
  },
];

export default rightlyRoutes;
